import PartneredIcon from "/public/assets/images/main/partnered-ico.png";
import Partnered01 from "/public/assets/images/main/partnered01.png"
import Partnered02 from "/public/assets/images/main/partnered02.png"
import styled from "styled-components";
import {SIZES} from "@/components/constants";
import {observer} from "mobx-react";
import {setFindItemId} from "@/utils/menu";
import {useStore} from "@/store";
import {useMediaQuery} from "react-responsive";
import {useRouter, useSearchParams} from "next/navigation";



const ResearchLabWrap = observer(({className}) => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const {navigationStore} = useStore();
    const router = useRouter();
    const productMenuId = "68db6825655492292e882c71";
    const labMenuId = "68db6cb6655492292e882ca9";
    const params = useSearchParams();
    const menuId = params.get("menu-id");
    const getDeepestFirstChild = (node) => {
        if (!node) return null;
        if (Array.isArray(node)) {
            if (node.length === 0) return null;
            return getDeepestFirstChild(node[0]);
        }
        if (node.children && Array.isArray(node.children) && node.children.length > 0) {
            return getDeepestFirstChild(node.children[0]);
        }
        return node;
    }
    return(
        <ResearchLabInner className={className}>
            <div className={"wrap-title"}>
                {
                    !isTablet ?
                        <h2>Partnered with Over 200 Global Universities<br/>and Research Labs</h2>
                        :
                        <h2>Partnered with Over<br/>200 Global Universities<br/>and Research Labs</h2>
                }
            </div>
            <div className={"partnered-wrap"}>
                <div className={"inner"}
                     onClick={() => {
                         const subList = setFindItemId(navigationStore.navigateList, productMenuId);
                         if(subList.children){
                             const lastChildNode = getDeepestFirstChild(subList);
                             const pagePath  = navigationStore.setFilterPageUrl(lastChildNode, undefined, menuId);
                             router.push(pagePath);
                         }
                     }}
                >
                    <div className="clip-mask"></div>
                    <div className="bg"></div>
                    <div className={"text-box"}>
                        <div className={"title"}>
                            <p>Product</p>
                            <div className={"img-wrap"}>
                                <img src={PartneredIcon?.src} alt={"화살표 아이콘"} />
                            </div>
                        </div>
                        <div className={"desc"}><span>신뢰할 수 있는 연구용 시약과 장비를 제공합니다.</span></div>
                    </div>
                </div>
                <div className={"inner"}
                     onClick={() => {
                         const subList = setFindItemId(navigationStore.navigateList, labMenuId);
                         if(subList.children){
                             const lastChildNode = getDeepestFirstChild(subList);
                             const pagePath  = navigationStore.setFilterPageUrl(lastChildNode, undefined, menuId);
                             router.push(pagePath);
                         }
                     }}
                >
                    <div className="clip-mask"></div>
                    <div className="bg"></div>
                    <div className={"text-box"}>
                        <div className={"title"}>
                            <p>Category</p>
                            <div className={"img-wrap"}>
                                <img src={PartneredIcon?.src} alt={"화살표 아이콘"}/>
                            </div>
                        </div>
                        <div className={"desc"}><span>분야별로 필요한 제품을 빠르게 찾아보세요.</span></div>
                    </div>
                </div>
            </div>
        </ResearchLabInner>
    )
});

const ResearchLabInner = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    height: calc(var(--vh) * 100);
    .wrap-title {
        font-weight: 700;
        font-size: 48px;
        line-height: 120%;
        text-align: center;
        letter-spacing: -0.02em;
        color: #0A0323;
        padding: 140px 0 104px;

        h2 {
            transition: all 1.5s;
            opacity: 0;
            transform: translate(0px, 40px);
        }
        h3{
            transition: all 2s;
            opacity: 0;
            transform: translate(0px, 60px);
        }
    }
    .partnered-wrap{
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        width: 100%;
        .inner{
            cursor: pointer;
            position: relative;
            display: flex;
            align-items: center;
            width: 50%;
            height: 100%;
            overflow: hidden;
            .clip-mask{
                position: absolute;
                top: 0;
                left: -0.5px; 
                width: calc(100% + 1px);
                height: 100%;
                transform: none;

                clip-path: inset(100% 100% 100% 100%);
                transition: clip-path 1.5s ease;
            }


            .bg{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            &:nth-of-type(1){
                .clip-mask{
                    background: url(${Partnered01?.src}) no-repeat center / cover;
                }
            }
            &:nth-of-type(2){
                .clip-mask{
                    background: url(${Partnered02?.src}) no-repeat center / cover;
                }
            }
            .text-box{
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                opacity: 0;
                transition: all 2s ease-in-out;
                .title{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    p{
                        font-weight: 700;
                        font-size: 54px;
                        line-height: 100%;
                        transition: all .15s;
                        letter-spacing: -0.02em;
                        color: #FFFFFF;
                    }
                    .img-wrap{
                        width: 24px;
                        opacity: 0;
                        display: none;
                        transition: all .15s;
                        transform: translateX(-40px);
                        img{
                            width: 100%;
                        }
                    }
                }
                .desc{
                    text-align: center;
                    margin-top: 30px;
                    span{
                        font-weight: 500;
                        font-size: 24px;
                        line-height: 120%;
                        color: #FFFFFF;
                    }
                }
            }
            &:hover{
                .text-box{
                    .title{
                        p{
                            transform: translateX(-16px);
                        }
                        .img-wrap{
                            opacity: 1;
                            transform: translateX(0);
                        }
                    }
                }
            }
        }

    }
    &.active{
        .wrap-title{
            h2{
                opacity: 1;
                transform: translate(0);
            }
            h3{
                opacity: 1;
                transform: translate(0);
            }
        }
        .partnered-wrap{
            .inner{
                .clip-mask{
                    clip-path: inset(0 0 0 0);
                }
                .text-box{
                    opacity: 1;
                    .img-wrap{
                        display: block;
                    }
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .wrap-title {
            font-weight: 700;
            font-size: 24px;
            line-height: 120%;
            letter-spacing: -0.02em;
            color: #0A0323;
            padding: 174px 0 75px;
        }
        .partnered-wrap{
            flex-wrap: nowrap;
            flex-direction: column;
            .inner{
                width: 100%;
                .text-box{
                    width: 100%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    opacity: 0;
                    transition: all 2s ease-in-out;
                    .title{
                        p{
                            font-weight: 700;
                            font-size: 32px;
                            line-height: 100%;
                            letter-spacing: -0.02em;
                        }
                        .img-wrap{
                            width: 16px;
                            opacity: 1;
                            margin-left: 7px;
                            transform: translateX(0);
                        }
                    }
                    .desc{
                        margin-top: 16px;
                        span{
                            font-weight: 500;
                            font-size: 14px;
                        }
                    }
                }
                &:hover{
                    .text-box{
                        .title{
                            p{
                                transform: translateX(0);
                            }
                        }
                    }
                }
            }

        }
    }
`
export default ResearchLabWrap;